import { getLabel } from "@weapp/utils";
import { SearchAdvancedInitAllDatas, SearchAdvancedStoreType } from "../../store/Store";
import { AnyObj } from "../../../../types/common";
import { getRandom, isEmpty, needSync } from "../../../../utils";
import { doDisabledOtherGroupFields, isCustomField, removeSuffix } from ".";
import { Dialog, MDialog } from "../../../../lib";
import { BROWSER_SUB_SUFFIX, isNeedBrowserIncludingSub } from "../../store/browser-including-subordinate";
import { isObservableArray } from "mobx";

const { toast } = MDialog;
const { message } = Dialog;

/*
  常用筛选相关逻辑
  需求：https://prototype.yunteams.cn/%E4%BD%95%E5%AE%8F%E9%98%B3/%E8%A1%A8%E5%8D%95/e10%E8%A1%A8%E5%8D%95%E8%AE%BE%E8%AE%A1%E5%99%A8/#id=1vvpfk&p=%E6%B5%8F%E8%A7%88%E6%95%B0%E6%8D%AE%E5%AE%9A%E4%B9%89
 */

// 选中常用筛选的数据逻辑, 更新data
export const updateSnapes = (_snapContent: SearchAdvancedInitAllDatas, store: SearchAdvancedStoreType, otherParams?: AnyObj) => {
  // 所有条件生效的条件是，后台条件+常用筛选的没有禁用的条件
  const {
    browserIncludingSubStore,
    browserConfigStore: {
      allDatas: { items }, maxOrder,
      datas, disableItemsKeys, hasDefaultConfig, readOnlyItems, hideLayouts, statusDatas, itemColMapping,
      customHideLayouts, wholeRowReadOnlyFieldsKeys, disableFieldsKeys, allFields, needTransBrowserConfigLayout,
    },
    isMobile,
    formStore,
    judgeEmptyFunc,
    commonCondition,
  } = store;
  let snapData = {};
  // 过滤常用筛选老数据内存储的多余"_subBrowserData_fromBrowserConfig"标记
  Object.keys(_snapContent?.data).forEach((dataKey: string) => {
    let key = dataKey;
    if (isCustomField(dataKey)) key = removeSuffix(dataKey);
    // 过滤常用筛选老数据内存储的多余"_subBrowserData_fromBrowserConfig"标记
    if ((isNeedBrowserIncludingSub(items?.[key]) || isNeedBrowserIncludingSub(_snapContent?.items?.[key])) && (Array.isArray(_snapContent.data[dataKey]) || isObservableArray(_snapContent.data[dataKey]))) {
      if (store?.browserIncludingSubStore?.disabledAfterCheckSnaps && _snapContent?.browserIncludingSubDatas?.[dataKey] && store?.commonFilterStore?.id) {
        snapData = {
          ...snapData,
          [dataKey]: (_snapContent.data[dataKey] as any)?.filter((da: any) => da.id?.indexOf(BROWSER_SUB_SUFFIX) < 0)
        }
      } else {
        snapData = {
          ...snapData,
          [dataKey]: (_snapContent.data[dataKey] as any)?.filter((da: any) => da.id?.indexOf(BROWSER_SUB_SUFFIX) < 0 && !da[`_${BROWSER_SUB_SUFFIX}__hide`])
        }
      }
    } else {
      const nowItem = items?.[key] || _snapContent?.items?.[key];
      if (!_snapContent.data?.[dataKey] && nowItem?.itemType === 'SELECT' && (nowItem?.multiple || nowItem?.otherParams?.multiple)) {
        snapData = {
          ...snapData,
          [dataKey]: [],
        }
      } else {
        snapData = {
          ...snapData,
          [dataKey]: _snapContent.data[dataKey],
        }
      }
    }
  })
  const snapContent: SearchAdvancedInitAllDatas = {
    ..._snapContent,
    data: snapData,
  }

  let labelTip: string[] = [];
  if (hasDefaultConfig) {
    let needAddCustomLayoutKeys: Set<string> = new Set([]); // 非后台设置的常用分组条件，有数据，但隐藏，需要新增到其他分组展示的字段ids集合
    let result = { ...datas }; // 后台条件保留
    let browserIncludingSubDatas = { ...browserIncludingSubStore?.subDatas, ...snapContent?.browserIncludingSubDatas };
    let tempDataKeys: Map<string, string> = new Map();
    snapContent?.data && Object.keys(snapContent?.data).forEach((dataKey: string) => {
      // 禁用
      let key = dataKey;
      if (isCustomField(dataKey)) key = removeSuffix(dataKey);
      // 1.禁用的字段，条件不保留
      if (disableItemsKeys.has(key)) {
        const label = itemColMapping.get(key)?.label;
        const tip = `"${label}"`;
        // 非条件字段，非空字段，禁用字段需要提示
        labelTip.indexOf(tip) < 0 && !items[dataKey]?.condition && !judgeEmptyFunc({ [dataKey]: snapContent?.data[dataKey] }) && labelTip.push(tip);
        return;
      }
      // 2.常用筛选的常用分组条件和默认条件(只读)冲突，放到其他分组展示
      // 3.常用筛选的常用分组条件和默认条件(隐藏)冲突，被覆盖
      // 4.常用筛选的常用分组条件冲突，且前台个人常用条件设置隐藏，同3，被覆盖
      // 3、4常用分组里面，常用筛选和后台设置的条件冲突的，以常用筛选为准，不保留后台的默认值
      if (!isCustomField(dataKey)) {
        // 3. 常用分组条件，只读，条件关系字段有值(items[dataKey].condition=true), 但后续跟进的其他非条件关系字段无值，则不视作需要回显的数据
        if (items[dataKey]?.condition && readOnlyItems.has(dataKey)) {
          const otherItems = wholeRowReadOnlyFieldsKeys.get(dataKey);
          if (!otherItems?.find((itKey) => items[itKey] && !items[itKey]?.condition && !isEmpty(snapContent?.data[itKey]))) return;
        }
        // 6. 常用分组条件、只读，条件字段空值，则不可覆盖常用分组数据
        if (!items[dataKey]?.condition && judgeEmptyFunc({ [dataKey]: snapContent?.data[dataKey] }) && readOnlyItems?.has(dataKey)) return;
      }
      if (!isCustomField(dataKey) && snapContent?.data[dataKey] && statusDatas[`${dataKey}_readonly`]) {

        // 常用分组条件，只读，条件关系字段有值(items[dataKey].condition=true), 但后续跟进的其他非条件关系字段无值，则不视作需要回显的数据
        if (items[dataKey]?.condition && readOnlyItems.has(dataKey)) {
          const otherItems = wholeRowReadOnlyFieldsKeys.get(dataKey);
          if (!otherItems?.find((itKey) => items[itKey] && !items[itKey]?.condition && !isEmpty(snapContent?.data[itKey]))) return;
        }

        if (!tempDataKeys.has(dataKey)) {
          const customId = `_customFields${getRandom()}`;
          tempDataKeys.set(dataKey, `${dataKey}${customId}`);
          wholeRowReadOnlyFieldsKeys.get(dataKey)?.forEach((k) => {
            tempDataKeys.set(k, `${k}${customId}`);
          });

          needAddCustomLayoutKeys.add(`${dataKey}${customId}`);
          result = {
            ...result,
            [`${dataKey}${customId}`]: snapContent?.data[dataKey],
          }
          if (browserIncludingSubDatas?.[dataKey]) {
            browserIncludingSubDatas = {
              ...browserIncludingSubDatas,
              [`${dataKey}${customId}`]: browserIncludingSubDatas?.[dataKey],
            }
            // 解决后台默认条件设置的含下级标记被常用筛选内配置影响的问题
            // 后台默认条件未设置含下级
            if (browserIncludingSubDatas?.[dataKey] && !result?.[dataKey]?.find((d: any) => d.id?.indexOf?.(BROWSER_SUB_SUFFIX) >= 0)?.value) {
              delete browserIncludingSubDatas?.[dataKey];
            }
          }
          browserIncludingSubDatas[dataKey] = browserIncludingSubStore.subDatas[dataKey];
          return;
        }
        const dk = tempDataKeys.get(dataKey);
        if (dk) {
          needAddCustomLayoutKeys.add(dk);
          result = {
            ...result,
            [dk]: snapContent?.data[dataKey],
          }
          if (browserIncludingSubDatas?.[dataKey]) {
            browserIncludingSubDatas = {
              ...browserIncludingSubDatas,
              [dk]: browserIncludingSubDatas?.[dataKey],
            }
            // 解决后台默认条件设置的含下级标记被常用筛选内配置影响的问题
            if (browserIncludingSubDatas?.[dataKey] && !result?.[dataKey]?.find((d: any) => d.id?.indexOf(BROWSER_SUB_SUFFIX) >= 0)?.value) {
              delete browserIncludingSubDatas?.[dataKey];
            }
          }
          browserIncludingSubDatas[dataKey] = browserIncludingSubStore.subDatas[dataKey];
        }
        return;
      }
      // 4. 不冲突的条件正常展示
      needAddCustomLayoutKeys.add(dataKey);
      result = {
        ...result,
        [dataKey]: snapContent?.data[dataKey],
      }
    })
    /**
      5.补充items内的默认值
     * （1）布局接口，字段默认值在items内的value设置（只有常用分组会存在问题，其他分组的默认值均会在data内保留）
     * （2）transCustomLayout的逻辑规定，initForm完全以datas的数据为准，因此会丢失1
     * （3）对于datas内不存在且items内存在的数据，兼容处理
     */
    Object.keys(items).forEach((itemkey) => {
      if (!isCustomField(itemkey) && !isEmpty(items[itemkey]?.value) && !needSync(itemkey, result)) {
        result = {
          ...result,
          [itemkey]: items[itemkey]?.value,
        }
      }
    })
    /* ------------------------------------------------------------------------ */
    const content = {
      ...snapContent,
      data: result,
      browserIncludingSubDatas,
    };
    /**
     * 用户前台开启的常用分组条件，选中常用筛选时，不应被隐藏
     */
    hideLayouts?.forEach((value) => {
      if (commonCondition?.find((c) => c.id === value)?.hide === false) hideLayouts?.delete(value);
    });

    const { customLayout } = store.transDatasStore.transCustomLayout(content, false, readOnlyItems, hideLayouts, customHideLayouts, {
      wholeRowReadOnlyFieldsKeys, disableFieldsKeys, forbidAddCustomLayout: true, needAddCustomLayoutKeys
    });
    // 其他分组排序：默认条件需按照顺序排在前面，新增的在后面补齐
    if (customLayout?.otherGroup && customLayout?.otherGroup[0]?.length > 1) {
      customLayout?.otherGroup[0]?.sort((a: any, b: any) => {
        const aOrder = statusDatas[`${a.items?.[0]}_${a.labelId}_sort`] || maxOrder + 1;
        const bOrder = statusDatas[`${b.items?.[0]}_${b.labelId}_sort`] || maxOrder + 1;
        return aOrder - bOrder;
      })
      store.formStore.setAllCustomLayout(customLayout, true);
    }
    // 禁用其他分组条件
    customLayout && doDisabledOtherGroupFields(store, customLayout, disableFieldsKeys);
    /* 无前台个人设置，allFields保持初始化状态 */
    if (needTransBrowserConfigLayout) formStore.setAllFields(allFields);
    // 禁用提示
    if (labelTip.length > 0 && !otherParams?.forbidMessage) {
      const content = getLabel('153305', '条件$s已在【浏览数据定义】禁用，无法生效').replace('$s', labelTip.join('、'));
      !isMobile ? message({
        type: 'info',
        content,
      }) : toast({
        content,
      })
    }
    return { content, needInit: false };
  }
  return { content: snapContent, needInit: true };
}